import { Component, OnInit, computed, inject } from '@angular/core';
import { environment } from 'src/environments/environment';

import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/services/auth.service';
import { BreakpointService } from 'src/app/services/breakpoint.service';
import { SharedService } from 'src/app/services/shared.service';

/**
 * application footer
 * holding required links to legal texts, etc.
 */
@Component( {
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
} )
export class FooterComponent implements OnInit {
    /** date, used to dynamically display year of copyright */
    readonly currentDate = new Date().getFullYear();
    isMobile = computed( () => this.#breakpointService.currentScreenSize() === 'XSmall' );
    showMatomoConsent = environment.optionalModules.showMatomoConsent;
    version = environment.version;

    #breakpointService = inject( BreakpointService );
    #sharedService = inject( SharedService );

    /** default language of links */
    #lang = 'en';
    /** links in footer */
    linkImprint = '';
    linkPrivacy = '';
    linkTerms = '';
    linkTermsUS = '';

    /** ignore in coverage */
    authService = inject( AuthService );
    #cookieService = inject( CookieService );

    /**
     * on init check if languauge cookie is set
     * to set links in footer
     */
    ngOnInit() {
        this.setFooterLinks();
    }

    /** set legal links in footer depending on user language */
    setFooterLinks() {
        // show links to legal pages depending on language //
        const cookieExists: boolean = this.#cookieService.check( 'language' );

        if ( cookieExists ) {
            this.#lang = this.#cookieService.get( 'language' );
        } else {
            this.#lang = navigator.language;
        }

        switch ( this.#lang ) {
            case 'de':
            case 'de-DE':
            case 'de-AT':
            case 'de-CH':
                this.linkImprint = 'https://www.riege.com/de/impressum/';
                this.linkPrivacy = 'https://www.riege.com/de/datenschutz/';
                this.linkTerms = 'https://www.riege.com/de/agb/';
                this.linkTermsUS = 'https://www.riege.com/terms-us/';
                break;
            default:
                this.linkImprint = 'https://www.riege.com/imprint/';
                this.linkPrivacy = 'https://www.riege.com/privacy/';
                this.linkTerms = 'https://www.riege.com/terms/';
                this.linkTermsUS = 'https://www.riege.com/terms-us/';
        }
    }

    /**
     * helper function to show consent banner
     * @param evt {object} click event
     */
    manageCookies( evt: Event ) {
        evt.preventDefault(); // prevent link to navigate
        const manage = this.#cookieService.check( 'scope.consent' );
        this.#sharedService.handleTrackingConsent( !manage );
    }
}
